import React from "react";
import {
  Home,
  WishList,
  ProtectedRoute,
  AdminProtectedRoute,
  CartProtectedRoute,
  PageNotFound,
  ProductDetails,
  ProductByCategory,
  CheckoutPage,
  CategoryListing,
  Category,
  Chat,
  SingleChat
} from "./shop";
import { DashboardAdmin, Categories, Products, Orders, Recommended } from "./admin";
import { UserProfile, UserOrders, SettingUser, Products1 } from "./shop/dashboardUser";
import Login from "./shop/auth/Login";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

/* Routing All page will be here */
const Routes = (props) => {
  return (
    <Router>
      <Switch>
        {/* Shop & Public Routes */}
        <Route exact path="/" component={Home} />
        <Route exact path ="/login" component={Login}/>

        {/* Added route for CategoryListing page */}
        <Route exact path="/categoryListing" component={CategoryListing} />

        <Route exact path="/wish-list" component={WishList} />
        <Route exact path="/products/:id" component={ProductDetails} />
        <Route exact path="/category/:id" component={Category} />
        <Route
          exact
          path="/products/category/:catId"
          component={ProductByCategory}
        />
        <CartProtectedRoute
          exact={true}
          path="/checkout"
          component={CheckoutPage}
        />

        {/* Chat routes */}
        <Route exact path="/chat" component={Chat} />
        <Route path="/chat/:name" component={Chat} />
        <Route exact path="/singlechat" component={SingleChat} />
        {/* Shop & Public Routes End */}

        {/* Admin Routes */}
        <AdminProtectedRoute
          exact={true}
          path="/admin/dashboard"
          component={DashboardAdmin}
        />
        <AdminProtectedRoute
          exact={true}
          path="/admin/dashboard/categories"
          component={Categories}
        />
        <AdminProtectedRoute
          exact={true}
          path="/admin/dashboard/products"
          component={Products}
        />
        <AdminProtectedRoute
          exact={true}
          path="/admin/dashboard/recommended"
          component={Recommended}
        />
        <AdminProtectedRoute
          exact={true}
          path="/admin/dashboard/orders"
          component={Orders}
        />
        {/* Admin Routes End */}

        {/* User Dashboard */}
        <ProtectedRoute
          exact={true}
          path="/user/profile"
          component={UserProfile}
        />
        <ProtectedRoute
          exact={true}
          path="/user/orders"
          component={UserOrders}
        />
        <ProtectedRoute
          exact={true}
          path="/user/setting"
          component={SettingUser}
        />
        <ProtectedRoute
          exact={true}
          path="/user/products"
          component={Products1}
        />
        {/* User Dashboard End */}

        {/* 404 Page */}

        <Route component={PageNotFound} />
      </Switch>
    </Router>
  );
};

export default Routes;
